export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
  HYBRID: 'hybrid',
};

export const THEME_STORAGE_KEY = 'pbz-theme';
export const DEFAULT_THEME = THEMES.HYBRID;

export const getStoredTheme = () => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved && Object.values(THEMES).includes(saved)) {
      return saved;
    }
  } catch {
    // fallback if localStorage is disabled
  }
  return DEFAULT_THEME;
};

export const setStoredTheme = (theme) => {
  try {
    if (Object.values(THEMES).includes(theme)) {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
    }
  } catch {
    // fallback
  }
};
